import { Stack, Text } from "@certn/cascadia";
import { SummaryMessage } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

export function CredentialsMissingBanner() {
  const { t } = useTranslation();

  return (
    <SummaryMessage
      children={
        <div>
          <Stack gap="space-2" orientation="horizontal">
            <Text color="text-base" style="global/heading-small">
              {t("ACIC registration is now required")}
            </Text>
          </Stack>
          <Stack gap="space-2" orientation="horizontal">
            <Text color="text-weak" style="global/body-secondary">
              {t(
                "Your order has been received and will be processed as soon as your ACIC accreditation is complete."
              )}
            </Text>
          </Stack>
          <div className={styles.padding}>
            <Stack gap="space-2" orientation="horizontal">
              <Text color="text-weak" style="global/body-secondary">
                {t(
                  "An Intercheck team member will be in touch shortly to guide you through the accreditation process."
                )}
              </Text>
            </Stack>
          </div>
        </div>
      }
      type="warning"
    />
  );
}

const styles = {
  padding: css({
    paddingTop: "var(--space-3)",
  }),
};
